<app-display-projects-list-view [allProjectsRawSetter]="projects" *ngIf="isDataAvailable" ></app-display-projects-list-view>

